import * as React from "react";
import * as ReactDOM from "react-dom";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import diyLightTheme = require("diy/material-ui/diyLightTheme");

import l10n from "diy/util/l10n";
import websiteData = require("diy/util/websiteData");

import Dialog from "./components/Dialog";
import Rating from "./components/Rating";

export enum CelebrationTypes { Vcard, Publish }

export default class MomentsToCelebrate {
    private celebrationContainer: HTMLElement;

    show(type: CelebrationTypes): boolean {
        if (!this.checkType(type)) {
            return false;
        }

        this.celebrationContainer = document.createElement('div');
        this.celebrationContainer.id = 'diy-moments-to-celebrate-dialog';
        document.body.appendChild(this.celebrationContainer);

        const styles = this.getStyles();

        ReactDOM.render(
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <Dialog
                    title={l10n('maintenance.dialog.title') }
                    autoDetectWindowHeight={false}
                    width={styles.width}
                    contentStyle={styles.content}
                    titleStyle={styles.title}
                    bodyStyle={styles.body}
                    dataTestId="moments-to-celebrate"
                    primaryButtonConfig={{
                        label: l10n('maintenance.dialog.closeLabel'),
                        callback: () => this.hide()
                    }}
                    >
                    <div style={styles.congratsMessage.root}>
                        <span style={styles.congratsMessage.congratsIcon}></span>
                        <span style={styles.congratsMessage.congratsText}>
                            {type === CelebrationTypes.Publish
                                ? l10n('maintenance.dialog.congratsText')
                                : l10n('maintenance.dialog.congratsTextVcard')
                            }
                        </span>
                    </div>
                    <Rating
                        showAlternative={type !== CelebrationTypes.Publish}
                    />
                </Dialog>
            </MuiThemeProvider>,
            this.celebrationContainer
        );

        return true;
    };

    hide(): boolean {
        if (this.celebrationContainer) {
            ReactDOM.unmountComponentAtNode(this.celebrationContainer);
            this.celebrationContainer.parentElement.removeChild(this.celebrationContainer);
            this.celebrationContainer = null;
        }
        return true;
    };

    private getStyles() {
        return {
            width: 750,
            content: {
                transform: 'translate3d(0, 0, 0)' // override the distance from viewport y=0
            },
            title: {
                textAlign: "center",
                color: "#004192"
            },
            body: {
                backgroundColor: "#FFFFFF"
            },
            congratsMessage: {
                root: {
                    padding: "30px 0 24px 0",
                    backgroundColor: "#0f95fc",
                    textAlign: "center",
                    margin: "0 18px"
                },
                congratsIcon: {
                    backgroundImage: "url(" + websiteData.getCdnUrl() + "/s/diy/common/img/icons/success_96x96.png)",
                    backgroundPosition: "0 0",
                    width: "96px",
                    height: "96px",
                    display: "block",
                    margin: "0 auto"
                },
                congratsText: {
                    fontSize: "26px",
                    lineHeight: "32px",
                    fontFamily: "'Open Sans',Arial,sans-serif",
                    fontWeight: "lighter",
                    color: "#FFFFFF",
                    margin: "0 100px",
                    textAlign: "center",
                    display: "block",
                    paddingTop: "20px"
                } as React.CSSProperties
            }
        };
    };

    private checkType(type: CelebrationTypes): boolean {
        return CelebrationTypes[type] ? true : false;
    };

    private getPageTrackingName(type: CelebrationTypes): string {
        let pageName: string;
        switch (type) {
            case CelebrationTypes.Vcard:
                pageName = 'Vcard-Congratulations';
                break;
            case CelebrationTypes.Publish:
                pageName = 'Publish-Congratulations';
                break;
            default:
                pageName = null;
                break;
        }
        return pageName;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/moments-to-celebrate/MomentsToCelebrate.tsx
 **/